function getRAsNamed(response, name) {
    const ras = (response||{}).responseActions || [];
    return ras.filter(ra => ra.Name === name || ra.name === name);
}

function addUnitLabel(response) {
    const ras = getRAsNamed(response, 'SendUnitLabel');
    ras.forEach(ra => response.UnitLabel = ra.UnitLabel);
    return response;
}

function getAbsoluteUrl(url) {
    const a = document.createElement('a');
    a.href = url;
    return a.hostname;
}

export default class AnalyticsResponseHandler {
    constructor(settings) {
        this._settings = settings;
    }

    doesHandle(message) {
        const t = (message || {}).messageType;
        const c = (this._settings || {}).messageConstants;
        return t && [c.converseRequest, c.appeventRequest, c.requestUnitRequest, c.getHistoryRequest].includes(t);
    }

    process(message) {
        if (!this.doesHandle(message)) { return message; }
        const resp     = message.response;
        const response = Array.isArray(resp) ? resp.map(addUnitLabel) : this.processResponse(resp);
        return Object.assign({}, message, { response });
    }

    processResponse(response) {
        addUnitLabel(response);
        if (response && response.UnitLabel) {
            const sendAnalytics = (Event, Url) => this.sendAnalytics(Event, response.UnitLabel, Url);

            // Send Impasse & Custom analytics events:
            getRAsNamed(response, 'InputNotUnderstood').forEach(ra => sendAnalytics('impasse', ra.Url));
            getRAsNamed(response, 'SendAnalytics'     ).forEach(ra => sendAnalytics(ra.Event , ra.Url));

            // Send Auto-Nav analytics event:
            const navUrl = response.navUrl;
            if (navUrl && navUrl.AutoNavigationType !== this._settings.navConstants.autoNavTypes.none) {
                sendAnalytics('redirect', navUrl.UrlAddress);
            }
        }
        sessionStorage.setItem("UnitLabel", response.UnitLabel);
        return response;
    }

    //This is manually injected into other link-handlers (see client.js):
    sendLinkAnalytics(link, response) {
        const url = link.UrlAddress || (link.Metadata||{}).UrlAddress;
        const unitLabel=sessionStorage.getItem("UnitLabel");
        const { type, source,origin  } = this._settings.Analytics;
        const data = { Event, unitLabel, url };
        const message = { type, source, data };
        console.log(JSON.stringify(message));
        
        if (url && response && response.UnitLabel) {
            const absUrl     = getAbsoluteUrl(url);
            const isInternal = this._settings.Analytics.InternalDomains.includes(absUrl);
            this.sendAnalytics(isInternal ? 'click' : 'offsite', response.UnitLabel, url);
        }
    }

    sendAnalytics(Event, UnitLabel, Url) {
        const { type, source, origin } = this._settings.Analytics;
        const data = { Event, UnitLabel, Url };
        const message = { type, source, data };

        //window.postMessage(data, origin);
        window.postMessage(message, origin);
        //adds cookie with analytics to maintain on test pages
        if(this._settings.MaintainAnalytics){
            //document.cookie('NITAnalytics', 'Message=' + message + "&" + "Origin" + origin);
            document.cookie = 'NITAnalytics=Message=' + JSON.stringify(message) + "&" + "Origin" + "=" + origin + ";";
        }
    }
}


// WEBPACK FOOTER //
// ./components/response-handlers/nextit-response-handler-analytics-amtrak.js